export const REACTION_OPTIONS = [
  { type: 'LIKE',    emoji: '👍', label: "J'aime",     icon: 'hand_thumbsup_fill' },
  { type: 'LOVE',    emoji: '❤️', label: 'Adore',      icon: 'heart_fill' },
  { type: 'CLAP',    emoji: '👏', label: 'Applaudir',  icon: 'hands_clap_fill' },
  { type: 'SUPPORT', emoji: '⭐', label: 'Soutien',    icon: 'star_fill' },
]

export function reactionEmoji(type) {
  return REACTION_OPTIONS.find((o) => o.type === type)?.emoji || '👍'
}

export function reactionIcon(type) {
  return REACTION_OPTIONS.find((o) => o.type === type)?.icon || 'hand_thumbsup'
}
